import img from "../../../img/creditimg1.svg";
import img2 from "../../../img/creditimg2.svg";
import img3 from "../../../img/creditimg3.svg";
import photo from "../../../img/blocimg.svg";
import photo2 from "../../../img/Group.svg";
import photo3 from "../../../img/googl.svg";
import photo4 from "../../../img/applee.png";

export const creditList = [
  {
    img: img,
    listTitle: "Card Type",
    listName: "Secondary",
    bankTitle: "Bank",
    bankName: "DBL Bank",
    cardTitle: "Card Number",
    cardName: "**** **** 5600",
    mainTitle: "Namain Card",
    mainName: "William",
    view: "View Details",
    bg: "rgb(231, 237, 255)",
  },
  {
    img: img2,
    listTitle: "Card Type",
    listName: "Secondary",
    bankTitle: "Bank",
    bankName: "BRC Bank",
    cardTitle: "Card Number",
    cardName: "**** **** 4300",
    mainTitle: "Namain Card",
    mainName: "Michel",
    view: "View Details",
    bg: "rgb(255, 224, 235)",
  },
  {
    img: img3,
    listTitle: "Card Type",
    listName: "Secondary",
    bankTitle: "Bank",
    bankName: "ABM Bank",
    cardTitle: "Card Number",
    cardName: "**** **** 7560",
    mainTitle: "Namain Card",
    mainName: "Edward",
    view: "View Details",
    bg: "rgb(255, 245, 217)",
  },
];
export const cardSetting = [
  {
    photo: photo,
    title: "Block Card",
    text: "Instantly block your card",
    bg: "rgb(255, 245, 217)",
  },
  {
    photo: photo2,
    title: "Change Pin Code",
    text: "Choose another pin code",
    bg: "rgb(231, 237, 255)",
  },
  {
    photo: photo3,
    title: "Add to Google Pay",
    text: "Withdraw without any card",
    bg: "rgb(255, 224, 235)",
  },
  {
    photo: photo4,
    title: "Add to Apple Pay",
    text: "Withdraw without any card",
    bg: "rgb(220, 250, 248)",
  },
  {
    photo: photo4,
    title: "Add to Apple Store",
    text: "Withdraw without any card",
    bg: "rgb(220, 250, 248)",
  },
];
